import Lifecycle from '@toasttab/lifecycle'

// Create instance and make it available to other modules inside the SPA
export const lifecycle = new Lifecycle()

// Make instance available to external JS
window.lifecycle = lifecycle
